import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconBrand = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M22 9V7H16.41C15.14 6.37 13.63 6 12 6C10.37 6 8.85 6.37 7.59 7H2V9H5.08C4.61 9.61 4.28 10.28 4.12 11H2V13H4.12C4.28 13.72 4.61 14.39 5.08 15H2V17H7.59C8.86 17.63 10.37 18 12 18C13.63 18 15.15 17.63 16.41 17H22V15H18.92C19.39 14.39 19.72 13.72 19.88 13H22V11H19.88C19.72 10.28 19.39 9.61 18.92 9H22ZM6 12C6 9.83 8.75 8 12 8C15.25 8 18 9.83 18 12C18 14.17 15.25 16 12 16C8.75 16 6 14.17 6 12Z" }))));
};
